require('./bower_components/angular/angular.min');
require('./bower_components/angular-route/angular-route.min');
require('./bower_components/angular-resource/angular-resource.min');
require('./bower_components/angular-cookies/angular-cookies.min');

require('./bower_components/angular-sanitize');
require('./bower_components/angular-ui-select');

require('./js/app');

var requireContext = require('webpack-require_context');

var replaceFrom = /\.\/(\w+)\.js/;
var replaceWith = '$1';

var filesContext = require.context('./js/filters');
requireContext(filesContext, replaceFrom, replaceWith);

var filesContext = require.context('./js/directives');
requireContext(filesContext, replaceFrom, replaceWith);

filesContext = require.context('./js/services');
requireContext(filesContext, replaceFrom, replaceWith);

filesContext = require.context('./js/controllers');
requireContext(filesContext, replaceFrom, replaceWith);

filesContext = require.context('./js/urls');
requireContext(filesContext, replaceFrom, replaceWith);

filesContext = require.context('./js/consts');
requireContext(filesContext, replaceFrom, replaceWith);

requireContext(require.context('./auth/js'), replaceFrom, replaceWith);


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 723
// module chunks = 0